module.exports = __webpack_public_path__ + "static/media/5-6.0b010bf7.mp3";